import React, { ReactElement } from 'react';
import Button from '@atlaskit/button';
import ArrowLeftCircleIcon from '@atlaskit/icon/glyph/arrow-left-circle';
import { N0, N800A } from '@atlaskit/theme/colors';
import { Background, getBackground } from './background-image';
import './page-background.scss';

interface PageBackgroundProps {
  className?: string;
  children?: ReactElement;
  heading: React.ReactNode;
  imageKey?: string;
  isBackButtonEnabled?: boolean | undefined;
  backButtonColor?: string;
  backButtonSecondaryColor?: string;
  lightBackgroundEnabled?: boolean;
  actions?: React.ReactNode;
  showImageKey?: boolean;
}

const getBackButton = (
  isBackButtonEnabled: boolean | undefined,
  backButtonColor: string,
  backButtonSecondaryColor: string
) => {
  return (
    <>
      {isBackButtonEnabled ? (
        <div className="back-button">
          <Button
            iconBefore={
              <ArrowLeftCircleIcon
                label="go back"
                size="medium"
                primaryColor={backButtonColor}
                secondaryColor={backButtonSecondaryColor}
              />
            }
            appearance="subtle"
            onClick={() => history.back()}
            className="page-back-button"
            testId="page-back-button"
          >
            <div style={{ color: backButtonColor }}>Back</div>
          </Button>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

const PageBackground = ({
  children,
  className,
  imageKey,
  heading,
  actions,
  isBackButtonEnabled,
  backButtonColor = N0,
  backButtonSecondaryColor = N800A,
  lightBackgroundEnabled = false,
  showImageKey = false,
}: PageBackgroundProps) => {
  const componentClassName = `page-background ${className ?? ''}`.trim();
  const imageKeyV2 = lightBackgroundEnabled ? Background.PPC_HEADER_LIGHT_BACKGROUND : Background.PPC_HEADER_BACKGROUND;

  const getHeaderBackground = () => {
    return showImageKey ? (
      <div className="background">
        <img src={getBackground(imageKey)} className="background-image" />
      </div>
    ) : (
      <div className="background-v2">
        <img src={getBackground(imageKeyV2)} className="background-image-v2" />
      </div>
    );
  };
  return (
    <>
      <div data-testid="page-background" className={componentClassName}>
        {getHeaderBackground()}
        <div className="configurable-header">
          {getBackButton(isBackButtonEnabled, backButtonColor, backButtonSecondaryColor)}
          <div className="title">
            <h1 className="heading">{heading}</h1>
          </div>
          <div className="actions-toolbar" data-testId="action-button">
            {actions}
          </div>
        </div>
        {children}
      </div>
    </>
  );
};

export default PageBackground;
